import { VehicleCode } from '@app/shared/models/vehicle-code';

export class VehicleManufacturer extends VehicleCode {

    public type_codes: string[];

    constructor(json?: any) {
        super(json);
    }

    public belongsToVehicleType(type: VehicleCode): boolean {
        return this.belongsToVehicleTypeCode(type.code);
    }

    public belongsToVehicleTypeCode(code: string): boolean {
        return this.type_codes && this.type_codes.indexOf(code) > -1;
    }
}
